import React, { FunctionComponent } from "react";
import styled from "styled-components";

import { H3Rox, CL } from "@/components/Typography";
import Device from "@/utils/device";

type StyleProps = {
  colour?: string;
  image?: string;
  reverse?: boolean;
};

type SessionsHouseSquaresProps = {
  title: string;
  colour: string;
  copy: string;
  image: string;
  textColour?: string;
  reverse?: boolean;
};

const SessionsHouseSquares: FunctionComponent<SessionsHouseSquaresProps> = (
  props: SessionsHouseSquaresProps
) => {
  return (
    <S.Section
      data-cy="SF-content-2023"
      reverse={props.reverse}
      colour={props.colour}
    >
      <S.Image image={props.image} reverse={props.reverse} />
      <S.CopyContainer reverse={props.reverse}>
        <H3Rox weight={100} color={props.textColour}>
          {props.title}
        </H3Rox>
        <CL color={props.textColour}>{props.copy}</CL>
      </S.CopyContainer>
    </S.Section>
  );
};

const S = () => {};

S.Section = styled.section<StyleProps>`
  position: relative;
  width: 100%;
  background: ${(p) => p.colour};
  display: flex;
  flex-direction: column;

  @media ${Device.desktop} {
    aspect-ratio: 3/1;
    flex-direction: ${(p) => (p.reverse ? "row-reverse" : "row")};
  }
`;

S.Image = styled.div<StyleProps>`
  width: 100%;
  background-image: url("${(p) => p.image}");
  background-position: bottom;
  background-size: cover;
  background-repeat: no-repeat;
  aspect-ratio: 1.5/1;

  @supports not (aspect-ratio: 1.5/1) {
    &::before {
      float: left;
      padding-top: 66%;
      content: "";
    }
    &::after {
      display: block;
      content: "";
      clear: both;
    }
  }

  @media ${Device.mobile} {
    aspect-ratio: 2/1;

    @supports not (aspect-ratio: 2/1) {
      &::before {
        float: left;
        padding-top: 50%;
        content: "";
      }
      &::after {
        display: block;
        content: "";
        clear: both;
      }
    }
  }

  @media ${Device.desktop} {
    width: 50%;
  }
`;

S.FontWeightWrap = styled.span`
  font-weight: 100;
`;

S.CopyContainer = styled.div<StyleProps>`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 20px;
  padding: 10%;

  > ${H3Rox} {
    font-size: 2rem;
  }

  @media ${Device.mobile} {

  > ${H3Rox} {
    font-size: 2.5rem;
    }
  }

  @media ${Device.tablet} {
    padding: 5% 10%;

    > ${H3Rox} {
     font-size: 3rem;
    }
  }

    @media ${Device.desktop} {
      padding: 5%;
      width: 50%;

    > ${H3Rox} {
     font-size: 3rem;
    }

    @media ${Device.largeScreen} {

    > ${H3Rox} {
     font-size: 4rem;
    }
  }
`;

S.ItalicWrap = styled.span`
  font-style: italic;
  font-family:
    Roxborough CF,
    sans-serif;
  font-weight: 100;
  font-size: 5rem;
`;

S.BoldWrap = styled.span`
  font-weight: 700;
`;

export default SessionsHouseSquares;
